import {AggregationInfo, AuthContextType} from "../types/types";
import {get} from "./helpers/restHelpers";

export async function getAggregations(authContext: AuthContextType): Promise<AggregationInfo[]> {
    const response = await get("/v1/aggregation/info?size=100", authContext);
    return response.data.features;
}